import { snackbar } from "@/core/controller/snackbar_controller";
import { headers } from '../const/headers';
import { serviceOrderDefault } from '../domain/serviceOrder/service_order.js'
import dayjs from "dayjs";

class ServiceOrderController {
    context = null;
    headers = headers;
    loading = false;
    search = "";
    dialog = false;
    form = serviceOrderDefault();
    searchClient = "";
    searchVehicle = "";
    searchTechnician = "";
    searchStatus = "";
    searchTaskType = "";
    statusSelected = 0;
    statusList = [
        {text: 'Todos', value: 0},
        {text: 'Ativos', value: 1},
        {text: 'Inativos', value: 2}
    ];
  
    serviceOrderPagination = {
        total: 0,
        items: []
    }

    options = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["name"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }


    clientPagination = {
        total: 0,
        items: []
    }
    
    clientOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["id"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    vehiclePagination = {
        total: 0,
        items: []
    }
    
    vehicleOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["plate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    technicianPagination = {
        total: 0,
        items: []
    }
    
    technicianOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["name"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    statusPagination = {
        total: 0,
        items: []
    }

    statusOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["id"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    taskTypePagination = {
        total: 0,
        items: []
    }

    taskTypeOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["id"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    constructor(
        context,
        fetchClientUseCaseImpl,
        fetchVehicleUseCaseImpl,
        fetchServiceOrderUseCaseImpl,
        fetchTechnicianUseCaseImpl,
        createServiceOrderUsecaseImpl,
        changeServiceOrderUsecaseImpl,
        deleteServiceOrderUsecaseImpl,
        fetchTaskTypeUseCaseImpl,
        fetchStatusUseCaseImpl
    ) {
        this.context = context;
        this.fetchClientUseCaseImpl = fetchClientUseCaseImpl,
        this.fetchVehicleUseCaseImpl = fetchVehicleUseCaseImpl,
        this.fetchServiceOrderUseCaseImpl = fetchServiceOrderUseCaseImpl,
        this.fetchTechnicianUseCaseImpl = fetchTechnicianUseCaseImpl,
        this.createServiceOrderUsecaseImpl = createServiceOrderUsecaseImpl,
        this.changeServiceOrderUsecaseImpl = changeServiceOrderUsecaseImpl,
        this.deleteServiceOrderUsecaseImpl = deleteServiceOrderUsecaseImpl,
        this.fetchTaskTypeUseCaseImpl = fetchTaskTypeUseCaseImpl,
        this.fetchStatusUseCaseImpl = fetchStatusUseCaseImpl
    }

    async paginate() {
        this.loading = true
        try {
            this.serviceOrderPagination = await this.fetchServiceOrderUseCaseImpl(this.options, this.search, this.statusSelected)
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false
        }
    }
    async taskTypePaginate() {
        try {
            this.taskTypePagination = await this.fetchTaskTypeUseCaseImpl(this.taskTypeOptions, this.searchTaskType)
        } catch (error) {
            console.log(error);
        }
    }
    async clientPaginate() {
        try {
          this.clientPagination = await this.fetchClientUseCaseImpl(this.clientOptions, this.searchClient)
        } catch (error) {
          console.log(error);
        }
    }
    async vehiclePaginate() {
        try {
          this.vehiclePagination = await this.fetchVehicleUseCaseImpl(this.vehicleOptions, this.searchVehicle)
        } catch (error) {
          console.log(error);
        }
    }
    async technicianPaginate() {
        try {
          this.technicianPagination = await this.fetchTechnicianUseCaseImpl(this.technicianOptions, this.searchTechnician);
        } catch (error) {
          console.log(error);
        }
    }
    async statusPaginate() {
        try {
            this.statusPagination = await this.fetchStatusUseCaseImpl(this.statusOptions, this.searchStatus)
        } catch (error) {
            console.log(error);
        }
    }

    async open() {
        this.dialog = true
        this.form = serviceOrderDefault()
    }

    close() {
        this.context.$refs.crud.resetValidation()
        this.dialog = false
    }

    async create() {
        if(this.context.$refs.crud.validate()) {
            try {
                this.loading = true

                this.form.startDate = dayjs(this.form.startDate).startOf('day').toISOString();
                this.form.endDate = dayjs(this.form.endDate).startOf('day').toISOString();

                if(this.form.id != 0) {
                    await this.changeServiceOrderUsecaseImpl(this.form.id, this.form)
                    snackbar.show({ message: "Alterado com sucesso!", color: "#008000", timeout: 3000 })
                } else {
                    await this.createServiceOrderUsecaseImpl(this.form)
                    snackbar.show({ message: "Adicionado com sucesso!", color: "#008000", timeout: 3000 })
                }
            } catch (error) {
                snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
            } finally {
                this.paginate()
                this.loading = false
                this.dialog = false
            }
        }
    }

    async change(item) {
        this.dialog = true
        this.form = { ...item }
    }

    async delete(item) {
        try {
          const confirm = await snackbar.confirm({ message: "Deseja realmente excluir o registro?", color: "primary", timeout: 5000 })
          if (confirm) {
            await this.deleteServiceOrderUsecaseImpl(item.id)
            this.paginate()
            snackbar.show({ message: "Resgistro excluído com sucesso!", color: "#008000", timeout: 1000 })
          }
        } catch (error) {
            snackbar.show({ message: error.toString() })
        } finally {
            this.paginate()
        }
    }

    changeStatus() {
        this.paginate()
    }
    watchOptions() {
        this.paginate()
    }
    watchSearch() {
        this.paginate()
    }
    watchClientOptions() {
        this.clientPaginate()
    }
    watchClientSearch() {
        this.clientPaginate()
    }
    watchVehicleOptions() {
        this.vehiclePaginate()
    }
    watchVehicleSearch() {
        this.vehiclePaginate()
    }
    watchTechnicianOptions() {
        this.technicianPaginate()
    }
    watchTechnicianSearch() {
        this.technicianPaginate()
    }
    watchTaskTypeOptions() {
        this.taskTypePaginate()
    }
    watchTaskTypeSearch() {
        this.taskTypePaginate()
    }
    watchStatusOptions() {
        this.statusPaginate()
    }
    watchStatusSearch() {
        this.statusPaginate()
    }
}

export default ServiceOrderController